export default [
  'Adultos',
  'Damas',
  'Jóvenes',
  'Adolescentes',
  'Menores'
]
